import { render } from "./list-product.vue?vue&type=template&id=d2f5178e&scoped=true"
import script from "./list-product.vue?vue&type=script&lang=js"
export * from "./list-product.vue?vue&type=script&lang=js"

import "./list-product.vue?vue&type=style&index=0&id=d2f5178e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f5178e"]])

export default __exports__